const POPULAR_CATEGORIES_EVENT = {
    "popular_categories_seen": {
        eventName: "popular categories seen",
        eventCategory: "Discovery"

    }
};

export default POPULAR_CATEGORIES_EVENT;
